import parse from "html-react-parser";

/**
 * Converts number to euro price.
 * @param {*} price price to be converted
 * @param {*} text where or not euro should be a sign in front or text behind the price.
 */

 export function toEuroFormat(price, text = false) {
   if (typeof price == "undefined" || price == null || isNaN(price) || price <= 0) {
     return null;
   }

    price = Number(price).toFixed(2);
    price = price.toString().replace(",", "TEMP").replace(".", ",").replace("TEMP", ".");
    price = price.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

    // if decimal is ,00 replace with ",-"
    if (price.endsWith(",00")) {
      price = price.slice(0, -3) + ",-";
    }

    if (text) {
      return price + " euro";
    }
    return "€" + price;
  }

  /**
 * Print HTML String to plain HTML Element
 * @param {*} text String to be converted
 */
export function printHTML(text) {
  if (!text) {
    return null;
  }
  return parse(text);
}


export const getAssetId = (data) => {
  if (typeof data == "string") {
    data = JSON.parse(data);
  }
  const files = data?.files;
  if (!files) {
    return null;
  }
  return files.map((item) => item.assetId);
};


export function formatYoastToMetadata(yoast, options = null) {
  const yoast_data = yoast?.yoast_head_json;
  if (!yoast_data) {
    return;
  }
  let robots = yoast_data?.robots;
  robots.index = robots?.index === "noindex" ? false : true;
  robots.follow = robots?.follow === "nofollow" ? false : true;
  let overwrite_data = {};
  const shared_data = options?.is_shared_data;
  if (shared_data) {
    const front_page_yoast = options?.front_page_yoast;
    const current_og_site_name = front_page_yoast?.og_site_name;

    const new_title = yoast?.title?.rendered + " - " + current_og_site_name;
    overwrite_data = {
      canonical: yoast_data?.og_url,
      url: shared_data?.og_permalink,
      title: new_title,
      siteName: front_page_yoast?.og_site_name,

    };
  }
  const open_graph = yoast_data?.schema?.["@graph"];

  const images = open_graph
    ?.filter((item) => item["@type"] === "ImageObject")
    .map(({ url, width, height }) => {
      return { url, width, height };
    });

  const result = {
    title: yoast_data?.title,
    robots: robots,
    locale: yoast_data?.og_locale,
    type: yoast_data?.og_type,
    description: yoast_data?.og_description,
    siteName: yoast_data?.og_site_name,
    twitter: {
      card: yoast_data?.twitter_card,
    },
    openGraph: {
      publishedTime: yoast_data?.article_modified_time,
      title: yoast_data?.title,
      description: yoast_data?.og_description,
      images: images,
    },
    ...overwrite_data,
  };

  return result;
}

export const Formatter ={
  yoastToMeta: formatYoastToMetadata,
}